package fr.arcplex.network.logging

import io.ktor.client.plugins.logging.Logger
import kotlin.io.println

object Logger : Logger {
    fun d(tag: String, msg: String) = println("[$tag] D: $msg")
    fun e(tag: String, msg: String) = println("[$tag] E: $msg")
    override fun log(message: String) {
        println("[Ktor] D: $message")
    }
}
